var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { isEqual, get, defaults, find, cloneDeep, assign, some } from 'lodash';
import { Table as AntTable } from 'antd';
import { throttle } from 'lodash';
import { FlexLayout } from '../flex-layout';
import { TypesManager } from '@comall-backend-builder/core';
import { TableActionColumn } from './table-action-column';
import { services } from '@comall-backend-builder/core'; // import './index.scss';

var DEFAULT_ACTION_COLUMN = {
  title: '',
  key: 'action',
  dataIndex: 'action',
  className: 'column-center'
}; //是否显示操作列

var shouldShowActionColumn = function shouldShowActionColumn(actionColumnConfig) {
  var _a = actionColumnConfig.items,
      items = _a === void 0 ? [] : _a;
  return some(items, function (_a) {
    var privilege = _a.privilege;
    return !privilege || services.privilege.check(privilege.path, privilege.level);
  });
};

var Table = function (_super) {
  __extends(Table, _super);

  function Table() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.setWrappedInstance = function (ref) {
      _this.wrappedInstance = ref;
    };
    /**
     * 渲染页脚
     * @return - react component
     */


    _this.renderFooter = function () {
      if (!_this.props.footer) {
        return;
      }

      var footer = _this.props.footer;
      var footerItems = [];
      var footerDirection = 'horizontal';
      var footerProps = {
        direction: footerDirection,
        items: footerItems
      };

      if (footer.showInfo !== false) {
        var text = '';

        if (typeof footer.showInfo === 'function') {
          text = footer.showInfo(_this.props);
        } else {
          var _a = _this.props,
              entity = _a.entity,
              selectedRowKeys = _a.selectedRowKeys,
              rowSelection = _a.rowSelection;
          var result = entity.result;
          var totalNum = get(entity, 'paging').totalNum;

          if (rowSelection && selectedRowKeys && selectedRowKeys.length && result && result.length) {
            text += services.language.getText('components.Table.selected') + " " + selectedRowKeys.length + "/" + result.length;
          }

          if (result) {
            text += services.language.getText('components.Table.loaded') + " " + result.length + "/" + totalNum;
          }
        }

        footerProps.items.push({
          component: 'Text',
          text: text,
          style: {
            display: 'block',
            lineHeight: '28px'
          }
        });
      } else {
        footerProps.items.push({
          component: 'Text',
          style: {
            display: 'block'
          }
        });
      }

      var buttonConfig = {
        component: 'button',
        flex: '0 0 auto',
        style: {
          marginRight: 5
        },
        type: 'primary'
      };

      if (footer.scrollLeftButton) {
        footerProps.items.push(Object.assign({}, buttonConfig, {
          icon: 'left',
          tooltip: 'Scroll Left',
          onClick: _this.scrollTo('left')
        }));
      }

      if (footer.scrollTopButton) {
        footerProps.items.push(Object.assign({}, buttonConfig, {
          icon: 'up',
          tooltip: 'Scroll Top',
          onClick: _this.scrollTo('top')
        }));
      }

      if (footer.scrollBottomButton) {
        footerProps.items.push(Object.assign({}, buttonConfig, {
          icon: 'down',
          tooltip: 'Scroll bottom',
          onClick: _this.scrollTo('bottom')
        }));
      }

      if (footer.scrollRightButton) {
        footerProps.items.push(Object.assign({}, buttonConfig, {
          icon: 'right',
          tooltip: 'Scroll Right',
          onClick: _this.scrollTo('right')
        }));
      }

      return React.createElement(FlexLayout, __assign({}, footerProps));
    };

    _this.scrollTo = function (type) {
      return function () {
        if (_this.wrappedInstance) {
          var wap = ReactDOM.findDOMNode(_this.wrappedInstance);

          if (wap === null) {
            return;
          }

          var tableBody = wap.querySelector('.ant-table-body');

          if (tableBody === null) {
            return;
          }

          var table = tableBody.querySelector('.ant-table-fixed');

          if (table === null) {
            return;
          }

          switch (type) {
            case 'top':
              tableBody.scrollTop = 0;
              break;

            case 'bottom':
              tableBody.scrollTop = table.scrollHeight - tableBody.clientHeight;
              break;

            case 'left':
              tableBody.scrollLeft = 0;
              break;

            case 'right':
              tableBody.scrollLeft = table.scrollWidth - tableBody.clientWidth;
              break;

            default:
          }
        }
      };
    };

    return _this;
  }

  Table.prototype.componentWillMount = function () {
    var onInit = this.props.onInit;

    if (onInit) {
      onInit();
    }
  };

  Table.prototype.componentWillReceiveProps = function (nextProps) {
    var _a = this.props,
        prevResult = _a.result,
        prevStatus = _a.requestStatus,
        prevSelected = _a.selectedRowKeys;
    var nextResult = nextProps.result,
        submitType = nextProps.submitType,
        nextStatus = nextProps.requestStatus,
        nextSelected = nextProps.selectedRowKeys,
        onSubmitSuccess = nextProps.onSubmitSuccess,
        onSubmitError = nextProps.onSubmitError,
        onSubmitFinish = nextProps.onSubmitFinish,
        rowSelection = nextProps.rowSelection,
        onRowSelectionChange = nextProps.onRowSelectionChange; // 处理条目选择状态变更

    if (rowSelection && !isEqual(prevSelected, nextSelected)) {
      rowSelection.onChange(nextSelected);
    } // 表格内容改变时清除所有行的选中状态


    if (rowSelection && onRowSelectionChange && submitType !== 'loadNextPage' && !isEqual(prevResult, nextResult)) {
      onRowSelectionChange([]);
    }

    if (prevStatus === 'pending' && nextStatus === 'success') {
      if (submitType && onSubmitSuccess) {
        onSubmitSuccess(nextProps.result, submitType);
      }

      if (submitType && onSubmitFinish) {
        onSubmitFinish();
      }

      if (submitType !== 'modify' && nextProps.infiniteScroll && get(nextProps, 'entity.paging.page') === 1) {
        this.scrollTo('top')();
      }
    }

    if (submitType && prevStatus === 'pending' && nextStatus === 'error') {
      if (onSubmitError) {
        onSubmitError(nextProps.result, submitType);
      }

      if (onSubmitFinish) {
        onSubmitFinish();
      }
    }
  };

  Table.prototype.componentDidMount = function () {
    var _this = this;

    var _a = this.props,
        infiniteScroll = _a.infiniteScroll,
        onLoadNextPage = _a.onLoadNextPage,
        onChange = _a.onChange;

    if (infiniteScroll && this.wrappedInstance) {
      // 处理滚动加载
      var wap = ReactDOM.findDOMNode(this.wrappedInstance);

      if (wap === null) {
        return;
      }

      var tableBody_1 = wap.querySelector('.ant-table-body');

      if (tableBody_1 === null) {
        return;
      }

      tableBody_1.addEventListener('scroll', throttle(function () {
        if (_this.props.requestStatus === 'pending') {
          return;
        }

        var table = tableBody_1.querySelector('.ant-table-tbody');

        if (!table) {
          return;
        }

        var distance = table.scrollHeight - tableBody_1.scrollTop - tableBody_1.clientHeight;

        if (distance < (infiniteScroll.distance || 100)) {
          var _a = _this.props,
              entity = _a.entity,
              columns = _a.columns,
              _b = _a.sort,
              sort = _b === void 0 ? {} : _b;

          var _c = entity.paging || {},
              page = _c.page,
              totalPage = _c.totalPage;

          if (page && totalPage && page >= totalPage) {
            return;
          }

          var column = find(columns, {
            property: sort.field
          });

          if (column && typeof column.sorter === 'function') {
            onChange && onChange({}, {}, {
              column: {},
              order: 'ascend',
              field: '',
              columnKey: ''
            }, {
              currentDataSource: []
            });
          }

          onLoadNextPage && onLoadNextPage();
        }
      }, 50));
    }
  };

  Table.prototype.render = function () {
    var _a = this.props,
        result = _a.result,
        requestStatus = _a.requestStatus,
        selectedRowKeys = _a.selectedRowKeys,
        columnConfigs = _a.columns,
        _title = _a.title,
        _b = _a.showHeader,
        showHeader = _b === void 0 ? true : _b,
        footer = _a.footer,
        rowSelection = _a.rowSelection,
        sort = _a.sort,
        onRowSelectionChange = _a.onRowSelectionChange,
        otherProps = __rest(_a, ["result", "requestStatus", "selectedRowKeys", "columns", "title", "showHeader", "footer", "rowSelection", "sort", "onRowSelectionChange"]);

    var columns = this.convertColumns(columnConfigs, sort);
    var pagination = this.convertPagination();

    var tableProps = __assign(__assign({}, otherProps), {
      columns: columns,
      pagination: pagination,
      showHeader: showHeader,
      ref: this.setWrappedInstance
    });

    if (typeof _title === 'function') {
      assign(tableProps, {
        title: _title
      });
    } else if (_title) {
      assign(tableProps, {
        title: function title() {
          return _title;
        }
      });
    }

    if (rowSelection) {
      assign(tableProps, {
        rowSelection: __assign(__assign({}, rowSelection), {
          selectedRowKeys: selectedRowKeys,
          onChange: onRowSelectionChange
        })
      });
    }

    if (footer) {
      if (typeof footer === 'function') {
        assign(tableProps, {
          footer: footer.bind(this)
        });
      } else {
        assign(tableProps, {
          footer: this.renderFooter
        });
      }
    }

    return React.createElement(AntTable, __assign({
      dataSource: result
    }, tableProps, {
      loading: requestStatus === 'pending'
    }));
  };
  /**
   * 获取匹配当前表格组件的列配置
   * @param {object} columnConfigs - 原始的列配置
   * @param {object} sort - 排序信息
   * @return {object} - 处理后的列配置
   */


  Table.prototype.convertColumns = function (columnConfigs, sort) {
    var _this = this;

    var _a = this.props,
        entity = _a.entity,
        params = _a.params,
        metainfo = _a.metainfo;
    var columns = columnConfigs.map(function (columnConfig, _index) {
      var column = assign({}, {
        property: columnConfig.property
      }); // 实体属性

      var property;
      var entityProperties = metainfo.properties;
      var configProperties = columnConfig.property.split('.');

      if (configProperties.length > 1) {
        var parent_1 = entityProperties;

        for (var _i = 0, configProperties_1 = configProperties; _i < configProperties_1.length; _i++) {
          var configProperty = configProperties_1[_i];
          property = parent_1[configProperty];

          if (!property) {
            throw new Error("Property " + columnConfig.property + " not found" + (" in Entity " + entity.id));
          }

          parent_1 = property.properties;
        }
      } else {
        property = entityProperties[columnConfig.property];
      }

      if (!property) {
        throw new Error("Property " + columnConfig.property + " not found in Entity " + entity.id);
      } // 列名称：取title；无title，则取displayName；无displayName，则取property


      var title = columnConfig.title || property.displayName || columnConfig.property; //当有reactElement形式的title时，防止开发环境下报错

      column.title = cloneDeep(title);
      column.key = columnConfig.key || columnConfig.property;

      if (columnConfig.property) {
        column.dataIndex = columnConfig.property;
      } // 渲染column


      column.render = function (text, record) {
        var typeSystem = TypesManager.get(property.type);

        if (record._modify && columnConfig.modifiable !== false) {
          return typeSystem.getControlComponent(__assign(__assign({}, columnConfig.controlConfig), {
            name: columnConfig.property,
            entity: entity,
            params: params,
            value: text,
            options: property.options,
            row: record,
            onChange: function onChange(value, name) {
              var onModifyChange = _this.props.onModifyChange;
              onModifyChange && onModifyChange(name, value, record);
            }
          }));
        } else {
          return typeSystem.getDisplayComponent(text, __assign(__assign({}, columnConfig.displayConfig), {
            name: columnConfig.property,
            options: property.options,
            row: record
          }));
        }
      }; // 设置列宽


      column.width = columnConfig.width ? Number(columnConfig.width) > 0 ? columnConfig.width + 'px' : columnConfig.width : '';
      column.colSpan = columnConfig.colSpan; // 设置排序

      if (columnConfig.sorter) {
        column.sorter = columnConfig.sorter;
      }

      column.sortOrder = sort && sort.field === columnConfig.property ? sort.order : false;

      if (columnConfig.fixed) {
        column.fixed = columnConfig.fixed;
      } // 设置列的对齐 class 及 自定义class


      column.className = '';

      if (columnConfig.align) {
        column.className += "column-" + columnConfig.align + " ";
      }

      if (columnConfig.className) {
        column.className += "" + columnConfig.className;
      }

      return column;
    });
    var actionColumnConfig = this.props.actionColumn;

    if (actionColumnConfig && shouldShowActionColumn(actionColumnConfig)) {
      // 组件中添加 “操作” 列
      var actionColumn = Object.assign({}, DEFAULT_ACTION_COLUMN, actionColumnConfig);
      delete actionColumn.items;
      var _b = this.props,
          params_1 = _b.params,
          onDeleteItem = _b.onDeleteItem,
          onModifyStart = _b.onModifyStart,
          onModifyConfirm = _b.onModifyConfirm,
          onModifyCancel = _b.onModifyCancel,
          entity_1 = _b.entity;
      var actionColumnProps_1 = {
        params: params_1,
        items: actionColumnConfig.items,
        onDeleteItem: onDeleteItem,
        onModifyStart: onModifyStart,
        onModifyConfirm: onModifyConfirm,
        onModifyCancel: onModifyCancel,
        entity: entity_1
      }; // column 的 render 方法

      actionColumn.render = function (_action, row, _index) {
        return React.createElement(TableActionColumn, __assign({
          row: row
        }, actionColumnProps_1));
      };

      columns.push(actionColumn);
    }

    return columns;
  };
  /**
   * 获取分页配置
   * @return {object} - ant 分页配置
   */


  Table.prototype.convertPagination = function () {
    var _a = this.props,
        result = _a.result,
        page = _a.page,
        perPage = _a.perPage,
        totalNum = _a.totalNum,
        paginationConfig = _a.pagination;
    var pagination;

    if (paginationConfig && result && result.length > 0) {
      pagination = {
        current: page,
        total: totalNum,
        pageSize: perPage
      };

      if (typeof paginationConfig === 'object') {
        defaults(pagination, paginationConfig);
      }
    } else {
      pagination = false;
    }

    return pagination;
  };

  Table.defaultProps = {
    rowKey: 'id'
  };
  return Table;
}(Component);

export { Table };